import remove from 'lodash/remove';
import { IGeometryPointFlat } from 'sharedtypes/math';

import { Pointofview } from './pointofview';
import { FIRST_FRAME_NAME } from '~/Services/Studio/Plugins/pointOfView';

/**
* Manage the movement of the camera along the journey and story
*/
export class PointofviewsManager {
    /**
    * List of all journey point of views
    */
    public pointofviews: Pointofview[] = [];

    /**
    * Set the list of point of views which will make the journey
    */
    public setPointofviews(pointofviews: IGeometryPointFlat[]): void {
        this.pointofviews = [];
        pointofviews.forEach((pointofview) => {
            this.addPointofview(pointofview);
        });
    }

    /**
    * Add a point of view in the journey
    */
    public addPointofview(pointofviewdata: IGeometryPointFlat): Pointofview {
        const newpointofview = new Pointofview(pointofviewdata);
        this._addPointofview(newpointofview);
        return newpointofview;
    }

    /**
    * @ignore
    */
    public _addPointofview(pointofview: Pointofview): void {
        this.pointofviews.push(pointofview);
    }

    /**
    * @ignore
    */
    public _removePointofview(pointofview: Pointofview): void {
        remove(this.pointofviews, (o) => pointofview.name === o.name);
    }

    /**
    * get the list of point of view
    */
    public getPointofviews(): Pointofview[] {
        return [...this.pointofviews];
    }

    public getFirstFramePov(): Pointofview {
        return this.pointofviews.find((x) => x.name === FIRST_FRAME_NAME);
    }
}
